import { combineReducers } from "redux";
import { postReducer } from "./posts";
import { authReducer } from "./auth"
import { commentReducer } from "./comments";
import { likeReducer } from "./like";
export default combineReducers({
    postReducer,
    authReducer,
    comment: commentReducer,
    likeReducer
    // selectedPostReducer
})